import { BaseModel } from './base';

export class  CertPermitRenewal extends BaseModel{
    certType:string;
    certName:string;
    description:string;
    expirationDate:string;
    notifyIn:number;
    notifyByDays:number;
    noOfNotification:string;
    Category:string;
    createdDate:Date;
    createdById:string;
    creayedByName:string;
    modifiedDate:Date;
    modifiedById:string;
    modifiedByName:string;
    subscriberId:string;
    siteId:string;
    certPermitNo: number;
    departmentId: string;
    departmentName: string;
}